import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, } from "react-bootstrap";
import { ACADEMIC_YEAR, CONTEXT_NAME } from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { FaPrint, FaRegCircleCheck } from "react-icons/fa6";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { FaDownload, FaWindowClose, } from "react-icons/fa";
import { CommonAxiosGet } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { useReactToPrint } from "react-to-print";

export default function BasePaymentStatus({ apiUrl, showNote, successNavigatePath, failureNavigatePath, noteNavigatePath }) {
    //console.log("failureNavigatePath::::", failureNavigatePath);
    let location = useLocation();
    let query = new URLSearchParams(location?.search);
    let componentRef = useRef();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "payment-reciept",
    });
    //console.log("query>>", query);
    const status = query.get('status');
    const trId = query.get('tpsltxnid');
    let navigate = useNavigate();
    const [modalStatus, setModalStatus] = useState(false);
    const [modalText, setModalText] = useState("");

    function getdata() {
        let Url = apiUrl + trId
        CommonAxiosGet(Url).then((res) => {
            if (res?.data?.status === true && res?.data?.scode === "01") {
                let data = res?.data?.data;
                //console.log("data>>", data)
                let showData = data[0];
                const paymentContent = status === "SUCCESS" ? (
                    <>
                        <div ref={componentRef}>
                            <div className="payment-success">
                                <h2 className="success-message fadeInUp">
                                    <FaRegCircleCheck />  &nbsp;
                                    Payment Successful!

                                </h2>
                            </div>
                            <div className="table-responsive mb-3 px-3">
                                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0" role="presentation"
                                    style={{ borderCollapse: 'collapse', background: "#a5820726" }}>
                                    <thead>
                                        <tr>
                                            <td>Candidate ID</td>
                                            <th>{showData?.candidate_id}</th></tr>
                                        <tr>
                                            <td>Candidate Name</td>
                                            <th>{showData?.applicant_name}</th></tr>
                                        <tr>
                                            <td>Transaction Id</td>
                                            <th>{showData?.tpsl_txn_id}</th></tr>
                                        <tr>
                                            <td>CFSS Transaction Id</td>
                                            <th>{showData?.cfss_txn_id}</th></tr>
                                        <tr>
                                            <td>Paid Amount</td>
                                            <th>{showData?.amount}</th></tr>
                                        <tr>
                                            <td>Paid Date</td>
                                            <th>{new Date(showData?.time_stamp).toLocaleString()}</th></tr>
                                        <tr>
                                            <td>Payment Status</td>
                                            <th>{showData?.status}</th></tr>

                                    </thead>
                                    <tfoot><tr>
                                        <td colSpan={2} className="text-end">
                                            <button type="button" className="btn btn-link" onClick={handleprint} >
                                                <FaDownload title="download invoice" style={{ fontSize: '22px' }} /></button>
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <table style={{ margin: "0 auto", width: "90%" }} role="presentation">
                            <thead>
                                <tr>
                                    <td colSpan={3} className="text-center"> <h5 onClick={() => navigate(successNavigatePath)} onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            navigate(successNavigatePath)
                                        }
                                    }} >
                                        <button className="btn btn-secondary" variant="primary">Print Application &nbsp;
                                            <FaPrint title="Print" style={{ fontSize: '22px' }} />
                                        </button>
                                    </h5></td>
                                    <td></td>
                                </tr>
                            </thead>
                        </table>
                        {showNote && (
                            <React.Fragment>
                                <h3 className="text-error mt-1 border p-3 fs-6 w-100">
                                    <b className="text-danger">Note  :</b>
                                    Your Application is Partially Submitted for {CONTEXT_NAME}-{ACADEMIC_YEAR} , Please Upload Documents
                                    <span>  <i style={{ background: "#2a9d8f" }}
                                        className="badge badge-success forgot fw-bold"
                                        onClick={() => navigate(noteNavigatePath)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                navigate(noteNavigatePath);
                                            }
                                        }}
                                        data-toggle="tooltip" animation="true"
                                    > Click Here </i> </span> to complete the application.

                                </h3><p className="text-end">(Please ignore it, if already uploaded !!)</p>
                            </React.Fragment>)}
                    </>
                ) : (
                    <>
                        <h3 className="text-danger text-center pt-5">
                            <HiOutlineExclamationCircle size={32} />&nbsp;Payment Failed, Please try again.
                            <i className="badge badge-success forgot mb-2 fw-bold"
                                onClick={() => { navigate(failureNavigatePath); }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        navigate(failureNavigatePath);
                                    }
                                }}
                                data-toggle="tooltip" animation="true" title="Click Me!"
                            > Click Here</i>
                        </h3>
                    </>
                );
                setModalText(paymentContent);
                setModalStatus(true);
            }
        })
    }
    useEffect(() => {
        if (status === "SUCCESS") {
            // console.log("status>>", status);
            getdata()
        }
        else {
            let failureContent = (<>
                <h3 className="text-danger text-center pt-5">
                    <HiOutlineExclamationCircle size={32} />&nbsp;Payment Failed, Please try again.
                    <i className="badge badge-success forgot mb-2 fw-bold"
                        onClick={() => { navigate(failureNavigatePath) }} onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                navigate(failureNavigatePath)
                            }
                        }}
                        data-toggle="tooltip" animation="true" title="Click Me!"
                    > Click Here</i>
                </h3>
            </>);
            setModalText(failureContent);
            setModalStatus(true);
        }

    }, [trId, status]);

    const closeModal = () => {
        if (status === 'SUCCESS') {
            navigate(successNavigatePath)
        }
        else {
            navigate(failureNavigatePath)
        }

        setModalStatus(false);
    };
    return (
        <React.Fragment>
            <div className='pop'>
                <Modal show={modalStatus} size="lg" className="mt-5 modal_xl" >
                    <Modal.Header style={{ backgroundColor: "rgb(220 162 77)", height: "60px" }}  >
                        <Modal.Title >
                            &nbsp; {CONTEXT_NAME}
                        </Modal.Title>
                        <button type="button" className='btn btn-end'
                            onClick={() => {
                                closeModal()
                            }} style={{ fadeType: "out" }}
                            variant="danger"
                            aria-label="Close"><h4><FaWindowClose className="text-danger" size={32} />

                            </h4></button>
                    </Modal.Header>
                    <Modal.Body className="bgModal"> {modalText}</Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    )
}
